import React from 'react'
import BonusDownloadButton from '../BonusDownloadButton'

const BonusItems = ({ plan }) => {
  const bonusItems = plan?.bonusItems
  const length = bonusItems?.length || 0
  if (length === 0) return null

  return (
    <>
      <h2 className='bonus-items-title'>
        Plus, {length > 1 ? 'these bonuses' : 'this bonus'} with this program
      </h2>
      <div className={`bonus-item-container${length < 4 ? '-large' : ''}`}>
        {bonusItems?.map((bonusItem) => (
          <div key={bonusItem.id} className={`bonus-card  no-touch`}>
            <div className='bonus-content-top'>
              <div className='bonus-image'>
                {bonusItem.image && (
                  <img src={bonusItem.image.url} alt={bonusItem.title} />
                )}
              </div>
              <div className='bonus-content'>
                <div className='bonus-title'>{bonusItem.title}</div>
                <div className='bonus-description'>{bonusItem.description}</div>
              </div>
            </div>

            {plan?.unlocked && bonusItem.file && (
              <BonusDownloadButton
                bonusId={bonusItem.id}
                file={bonusItem.file}
              />
            )}
          </div>
        ))}
      </div>
    </>
  )
}

export default BonusItems
